import { WAAS_LAST_SESSION_ACTIVITY_KEY } from "@/constants/auth";

export function readLastSessionActivityAt(): number | null {
  if (typeof sessionStorage === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(WAAS_LAST_SESSION_ACTIVITY_KEY);
    if (raw == null || raw.trim() === "") return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) ? parsed : null;
  } catch {
    return null;
  }
}

export function writeLastSessionActivityAt(at: number): void {
  if (typeof sessionStorage === "undefined") return;
  try {
    sessionStorage.setItem(WAAS_LAST_SESSION_ACTIVITY_KEY, String(at));
  } catch {
    /* ignore */
  }
}

export function shouldRefreshAuthzAfterIdle(
  now: number,
  lastActivityAt: number | null,
  thresholdMs: number,
): boolean {
  if (lastActivityAt == null) return false;
  return now - lastActivityAt > thresholdMs;
}
